"use client";

import React from "react";
import { ArrowRight, HardHat, Ruler, ShieldCheck, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "PRECISION EARTHWORKS",
  description: "From sculpting drainage systems to performing sub-grade structural leveling, we specialize in executing on your vision. If your project involves alterations to your property, we have the technical mastery to get it done right the first time.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575346/img/shoreline_restoration_heavy_equipment.png",
  icon: ShieldCheck,
  link: "/SiteEngineeringHubPage"
}, {
  title: "Site Preparation",
  description: "fFrom new lot development to demolition, we handle all phases of site work including clearing, grading, digging, final grade, yard installation and hardscaping.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575346/img/site_preparation_excavator_dirt.png",
  icon: HardHat,
  link: "/SiteEngineeringHubPage"
}, {
  title: "ROAD AND PATHWAYS",
  description: "We craft roads and pathways with cutting‑edge techniques, premium materials, and specialty aggregates, delivering stunning, long‑lasting surfaces.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575346/img/septic_systems_installation_trench.png",
  icon: Ruler,
  link: "/SiteEngineeringHubPage"
}];
export default function TheEngineeringHub() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-engineering-hub" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: 'linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)',
      backgroundSize: '4rem 4rem'
    }}>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={headerReveal.ref} className={`mb-16 md:mb-24 max-w-3xl transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="flex items-center gap-4 mb-6">
            <div className="h-px w-12 bg-primary"></div>
            <span className="text-primary font-bold tracking-widest uppercase text-sm">Core Capabilities</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-6">The Service&nbsp;<span className="text-primary" data-ast-id="f:/src/pages/Home/sections/TheEngineeringHub.tsx|sig:p8yc2l" data-ast-start="2860" data-ast-end="2901">Hub</span></h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl">Comprehensive earthworks for every scale of ambition. From major commercial developments to precision residential builds, we're big enough to tackle the big stuff and nimble enough for any project—delivering on your vision for your home or business.</p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-3 border-t border-l border-border transition-all duration-1000 delay-200 ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group relative aspect-square md:aspect-[4/5] overflow-hidden border-r border-b border-border bg-muted">
              {}
              <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent p-8 flex flex-col justify-end transition-opacity duration-500 group-hover:opacity-0">
                <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight text-white">
                  {service.title}
                </h3>
                <div className="flex items-center mt-4 text-primary font-bold text-sm uppercase tracking-wider">
                  View Specs <ChevronRight className="w-4 h-4 ml-1" />
                </div>
              </div>

              {}
              <div className="absolute inset-0 bg-secondary/95 p-8 flex flex-col justify-center transform -translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out z-10 border-b-4 border-primary">
                <div className="flex justify-between items-start mb-6">
                  <service.icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
                  {service.badge && <Badge variant="default" className="bg-primary text-primary-foreground uppercase tracking-wider font-bold text-[10px] py-1 px-2 rounded-sm">
                      {service.badge}
                    </Badge>}
                </div>
                
                <h3 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-4 text-white">
                  {service.title}
                </h3>
                
                <p className="text-muted-foreground mb-8 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="mt-auto">
                  <Button asChild variant="outline" className="w-full border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-none uppercase tracking-widest font-bold h-12">
                    <Link to={service.link}>
                      Explore Service <ArrowRight className="ml-2 w-5 h-5" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild size="lg" className="rounded-none uppercase tracking-widest font-black h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/SiteEngineeringHubPage">View All Excavating Services</Link>
          </Button>
        </div>
      </div>
    </section>;
}